import {TableItem, TableItemForm} from '../forms/table-field/table-field.model';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';

export class SequentialOrderAction  {
  uuid?: string | null;
  name: string;
  signatureRequired: boolean;
  permissions = {};
  fields: TableItem[];
  renderTag: string;

}

export class SequentialOrderActionForm {
  name = new FormControl();
  uuid = new FormControl(null);
  renderTag = new FormControl();
  signatureRequired = new FormControl();
  fields = new FormArray([], [Validators.required]);

  constructor(seqAction: SequentialOrderAction) {
    if (seqAction.name) {
      this.name.setValue(seqAction.name);
    }
    if (seqAction.uuid) {
      this.uuid.setValue(seqAction.uuid);
    }
    if (seqAction.renderTag) {
      this.renderTag.setValue(seqAction.renderTag);
    }
    if (seqAction.signatureRequired) {
      this.signatureRequired.setValue(seqAction.signatureRequired);
    }
    if (seqAction.fields) {
      seqAction.fields.sort((a, b) => (a.sort > b.sort) ? 1 : ((b.sort > a.sort) ? -1 : 0));
      seqAction.fields.forEach(c => {
        this.fields.push(
          new FormGroup(new TableItemForm(c))
        );
      });
    }
  }

}
